define('Fotronic_VertexCertificates/js/cert_popup',['jquery','Magento_Ui/js/modal/modal'],function($,modal){
    "use strict";
    return {
        showCertPopUp : function ()
        {
            var options = {
                type: 'popup',
                responsive: true,
                innerScroll: true,
                title: 'Register for Tax Exemption',
                modalClass: 'vertex-exemption-popup',
                buttons: [{
                    text: $.mage.__('Close'),
                    class: '',
                    click: function () {
                        this.closeModal();
                    }
                }]
            };

            var popup = modal(options, $('#modal-overlay'));
            $('#modal-overlay').modal('openModal');
        },
        hideCertPopUp : function ()
        {
            $('#modal-overlay').modal('closeModal');
        }
    }
});

